/*
 * A Status Tag component with an optional tooltip on hover
 */
import React, { useMemo } from 'react';
import { Tag, Tooltip } from '../../components';
import classNames from 'classnames';

import './StatusTag.scss';

export const StatusTag = ({ text, toolTip }) => {
    const classes = classNames('status-tag', {
        'status-ready': text === 'Ready',
        'status-not-ready': text === 'Not Ready',
        'status-unknown': text === 'Unknown',
    });

    const tag = useMemo(() => <Tag className={classes}>{text}</Tag>, [classes, text]);

    return toolTip ? (
        <Tooltip title={toolTip} placement="right">
            {tag}
        </Tooltip>
    ) : (
        tag
    );
};
